import { onContentReady } from "@story/story_assets/utils";
import L from "leaflet";

const API_KEY = "_jpgAaER1KjIjQgoEsttuTaMtXdymehpkKPdvjq29M0";

function initBranchMap(element) {
	const latitude = element.getAttribute("data-latitude");
	const longitude = element.getAttribute("data-longitude");
	const mapCenter = [latitude, longitude];
	const mapZoom = element.getAttribute("data-zoom") || 10;

	const map = L.map(element).setView(mapCenter, mapZoom);
	map.attributionControl.setPrefix(false);

	L.tileLayer(`https://api.mapy.cz/v1/maptiles/basic/256@2x/{z}/{x}/{y}?apikey=${API_KEY}`, {
		minZoom: 0,
		maxZoom: 19,
		attribution: "<a href='https://api.mapy.cz/copyright' target='_blank'>&copy; Seznam.cz a.s. a další</a>",
	}).addTo(map);

	L.marker(mapCenter, {
		icon: L.icon({
			iconUrl: RAILS_ASSET_URL("marker-icon.png"),
			iconSize: [25, 41],
			iconAnchor: [25 / 2, 41],
		})
	}).addTo(map);
}

onContentReady(function(parent) {
	for (const element of parent.querySelectorAll(".branch-map:not(.initialized)")) {
		element.classList.add("initialized");

		initBranchMap(element);
	}
});